var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["filter"]: () => __WEBPACK_EXTERNAL_MODULE_rxjs_operators_68fec7eb__.filter, ["switchMap"]: () => __WEBPACK_EXTERNAL_MODULE_rxjs_operators_68fec7eb__.switchMap });